import axios from "axios";
import { SET_LOADER, CLEAR_LOADER, CLEAR_ERRORS } from "../../types";

import Alert from "react-s-alert";
import { setErrors } from "../errorActions";
import { serverApi } from "../../../config/Keys";

export const sendSmsAdmin =
  (formData, onSuccessSms, onErrorrSms) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let sms = await axios.post(`${serverApi}/admin/sms`, formData);
      if (sms.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Sms Sent Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
      onSuccessSms();
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onErrorrSms();
      // Alert.error(`<h4>${err}</h4>`, {
      //   position: "top-right",
      //   effect: "bouncyflip",
      //   beep: true,
      //   html: true,
      //   timeout: 3000,
      //   offset: 35,
      // });
    }
  };

export const sendSmsForAdmin =
  (formData, token, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let send_sms_diner = await axios.post(
        `${serverApi}/admin/sms`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (send_sms_diner.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onError(err);
    }
  };

export const sendNotificationForAdmin =
  (formData, token, onSuccess, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let send_sms_diner = await axios.post(
        `${serverApi}/admin/notifications`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (send_sms_diner.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onError(err);
    }
  };

export const sendNotificationAdmin =
  (formData, onSuccessNotification, onErrorrNotification) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let notification = await axios.post(
        `${serverApi}/admin/notifications?isUser=true`,
        formData
      );
      if (notification.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Notification Sent Successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
      onSuccessNotification();
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onErrorrNotification();
      Alert.error(`<h4>${err}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

export const resetPassword =
  (formData, actionPerform, onSuccessResetPassword, onErrorrResetPassword) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let reset_password = await axios.post(
        `${serverApi}/admin/reset-password${actionPerform ? "?user=true" : ""}`,
        formData
      );
      if (reset_password.status === 201) {
        dispatch({ type: CLEAR_LOADER });
      }
      onSuccessResetPassword();
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onErrorrResetPassword();
      Alert.error(`<h4>${err}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };
